



































import {Component, Vue} from 'vue-property-decorator';

interface ImageCredit {
    title: string;
    fileName: string;
    authorName: string;
    authorPage: string;
}

@Component
export default class AssetsDrawer extends Vue {
    private assetsCredits: ImageCredit[] = [
        {
            title: 'Mouse Svg',
            fileName: 'mouse.svg',
            authorName: 'Those Icons',
            authorPage: 'https://www.flaticon.com/authors/those-icons',
        },
        {
            title: 'Cat Svg',
            fileName: 'cat.svg',
            authorName: 'Freepik',
            authorPage: 'https://www.freepik.com/',
        },
        {
            title: 'Milk Svg',
            fileName: 'milk.svg',
            authorName: 'Freepik',
            authorPage: 'https://www.freepik.com/',
        },
        {
            title: 'Wall Svg',
            fileName: 'wall.svg',
            authorName: 'Pixel Perfect',
            authorPage: 'https://www.flaticon.com/authors/pixel-perfect',
        },
    ];
}
